import React from "react";
import "./EmptyState.css";

const EmptyState = ({ 
  title = "No NFTs Found", 
  message = "We couldn't find any items in the marketplace at the moment.",
  icon = "search",
  showButton = false,
  buttonText = "Browse Collections",
  onButtonClick = null 
}) => {
  const renderIcon = () => {
    switch (icon) {
      case "search":
        return (
          <svg width="80" height="80" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="11" cy="11" r="7" stroke="currentColor" strokeWidth="2" />
            <path d="M20 20L16 16" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
            <path d="M11 8V14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
            <path d="M8 11H14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
          </svg>
        );
      case "box":
        return (
          <svg width="80" height="80" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3 9L12 4L21 9L12 14L3 9Z" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" />
            <path d="M3 15L12 20L21 15" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" />
            <path d="M12 14V20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
          </svg>
        );
      case "image":
        return (
          <svg width="80" height="80" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="3" y="3" width="18" height="18" rx="2" stroke="currentColor" strokeWidth="2" />
            <circle cx="8.5" cy="8.5" r="1.5" fill="currentColor" />
            <path d="M21 15L16 10L5 21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        );
      default:
        return (
          <svg width="80" height="80" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="2" />
            <path d="M12 8V12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
            <circle cx="12" cy="16" r="0.5" fill="currentColor" stroke="currentColor" strokeWidth="1" />
          </svg>
        );
    }
  };

  return (
    <div className="empty-state-container">
      <div className="empty-state-content">
        <div className="empty-state-icon">
          {renderIcon()}
          <div className="empty-state-icon-glow"></div>
        </div>
        <h2 className="empty-state-title">{title}</h2>
        <p className="empty-state-message">{message}</p>
        {showButton && buttonText && (
          <button className="btn BtnBlack empty-state-button" onClick={onButtonClick}>
            {buttonText}
          </button>
        )}
        <div className="empty-state-decoration">
          <div className="decoration-circle decoration-circle-1"></div>
          <div className="decoration-circle decoration-circle-2"></div>
          <div className="decoration-circle decoration-circle-3"></div>
        </div>
      </div>
    </div>
  );
};

export default EmptyState;

